import { HttpService } from '../main/HttpService.js';

/**
 * Web API client for communicating the Admin Service. This service normally resides on the
 * same server as the one serving this javascript file (the url probably won't have a domain).
 */
export class AdminService extends HttpService {
  constructor(serviceUrl) {
    super(serviceUrl);
    this.sameSiteOnly = true; // See super() for info
  }

  async submitError(error, signal) {
    return await this.postJsonObject('SubmitError', error, signal);
  }

  async createLoginKey(signal) {
    return await this.post('login-key', null, null, signal);
  }
}
